import { Audit } from './Audit';
import { MapData_Workflow } from './MapData';
import { Project_Base } from './Project';
import { User_Base } from './User';
import { StrapiModel_Base } from './StrapiModel';

export enum UploadTask_Status {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
}

export const UploadTask_ModelUtil = {
  getStatusColor: (status: UploadTask_Status) => {
    switch (status) {
      case UploadTask_Status.PENDING:
        return 'gold';
      case UploadTask_Status.PROCESSING:
        return 'blue';
      case UploadTask_Status.SUCCESS:
        return 'green';
      case UploadTask_Status.FAILED:
        return 'red';
      default:
        return 'default';
    }
  },
  getTextStatus: (status: UploadTask_Status) => {
    switch (status) {
      case UploadTask_Status.PENDING:
        return 'Chờ xử lý';
      case UploadTask_Status.PROCESSING:
        return 'Đang xử lý';
      case UploadTask_Status.SUCCESS:
        return 'Thành công';
      case UploadTask_Status.FAILED:
        return 'Thất bại';
      default:
        return 'Không xác định';
    }
  },
};

export interface UploadTask_Metadata {
  force_workflow?: MapData_Workflow;
  force_srs?: string; // Apply this SRS to all map data and ignore the SRS in the files
  force_srs_name?: string; // Display name of the SRS
  fallback_srs?: string; // If map data has no srs, then use it
}

/**
 * UploadTask
 *
 * Người dùng upload lên sẽ tạo thành 1 UploadTask,
 * 1 UploadTask có thể chứa nhiều MapData
 */
export type UploadTask_Base = StrapiModel_Base & Audit & {
  title: string;
  description: string;
  status: UploadTask_Status;
  metadata: UploadTask_Metadata | string; // json
  owner?: User_Base;
  project?: Project_Base;
};
